/**
 * Validadores do formulário de criação da Taxa Setup Avulsa. Ficam no módulo (e não em outros utilitários)
 * para o módulo novo não depender de código de fluxos antigos.
 */

export const onlyDigits = (value?: string | null): string => String(value ?? "").replace(/\D/g, "");

const allSameDigits = (digits: string): boolean => /^(\d)\1+$/.test(digits);

export const isValidCpf = (value?: string | null): boolean => {
	const digits = onlyDigits(value);
	if (digits.length !== 11 || allSameDigits(digits)) return false;

	const checkDigit = (length: number): number => {
		let sum = 0;
		for (let i = 0; i < length; i += 1) sum += Number(digits[i]) * (length + 1 - i);
		const rest = (sum * 10) % 11;
		return rest === 10 ? 0 : rest;
	};

	return checkDigit(9) === Number(digits[9]) && checkDigit(10) === Number(digits[10]);
};

export const isValidCnpj = (value?: string | null): boolean => {
	const digits = onlyDigits(value);
	if (digits.length !== 14 || allSameDigits(digits)) return false;

	const checkDigit = (length: number): number => {
		const weights = length === 12 ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2] : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
		const sum = weights.reduce((total, weight, index) => total + Number(digits[index]) * weight, 0);
		const rest = sum % 11;
		return rest < 2 ? 0 : 11 - rest;
	};

	return checkDigit(12) === Number(digits[12]) && checkDigit(13) === Number(digits[13]);
};

export const isValidDocument = (value?: string | null): boolean => {
	const digits = onlyDigits(value);
	return digits.length > 11 ? isValidCnpj(digits) : isValidCpf(digits);
};

export const isValidPhone = (value?: string | null): boolean => {
	const digits = onlyDigits(value);
	return digits.length === 10 || digits.length === 11;
};
